const theme = {
	colors: {
		green1000: '#39442B',
		yellow1000: '#FAFF86',
		gray1000: '#F1F1EA',
		lightGray1000: '#FDFDF2',
		white1000: '#FFFFFF',
		green100: '#E9EBDC',
		error1000: '#FF7D82',
	},

	mediaQuery: {
		desktopSizeXL: '2560px',
		desktopSizeL: '1920px',
		desktopSizeM: '1536px',
		desktopSizeS: '1366px',
		tabletSize: '1280px',
		tabletSizeX: '1024px',
		tabletSizeS: '768px',

		desktopSizeXLMin: '2559px',
		desktopSizeLMin: '1919px',
		desktopSizeMMin: '1535px',
		desktopSizeSMin: '1365px',
		tabletSizeMin: '1279px',
		tabletSizeXMin: '1023px',
		tabletSizeSMin: '767px',
	},

	form: {
		colors: {
			//! Box Shadow
			boxShadowColor: 'unset',

			//! Empty Text Color
			emptyTextColor: '#8C9B8B',

			//! Message colors
			successMessageColor: '#4CAF50',
			successMessageBorderColor: '#4CAF50',
			successMessageBgColor: 'rgba(76, 175, 80, 0.1)',
			errorMessageColor: '#FF7D82',
			errorMessageBorderColor: '#FF7D82',
			errorMessageBgColor: '#FF7D82',

			//! Label
			labelColor: '#39442B',
			labelHoverColor: '',
			labelFocusColor: '',
			labelActiveColor: '',
			labelErrorColor: '#FF7D82',
			labelDisabledColor: '#39442B',

			//! Input
			inputColor: '#39442B',
			inputHoverColor: '',
			inputFocusColor: '#39442B',
			inputActiveColor: '',
			inputErrorColor: '#FF7D82',
			inputDisabledColor: '#39442B',

			inputPlaceholderColor: '#39442B',
			inputPlaceholderHoverColor: '',
			inputPlaceholderFocusColor: '#39442B',
			inputPlaceholderActiveColor: '',
			inputPlaceholderErrorColor: '#FF7D82',
			inputPlaceholderDisabledColor: '',

			inputBorderColor: '#39442B',
			inputBorderHoverColor: '',
			inputBorderFocusColor: '',
			inputBorderActiveColor: '',
			inputBorderErrorColor: '#FF7D82',
			inputBorderDisabledColor: '#E9EBDC',

			inputBgColor: '#FDFDF2',
			inputHoverBgColor: '',
			inputFocusBgColor: '',
			inputActiveBgColor: '',
			inputErrorBgColor: '#FFEFE5',
			inputDisabledBgColor: '#E9EBDC',

			//! Select
			selectColor: '#39442B',
			selectHoverColor: '',
			selectFocusColor: '#39442B',
			selectActiveColor: '',
			selectErrorColor: '#FF7D82',
			selectDisabledColor: '',

			selectPlaceholderColor: '#39442B',
			selectPlaceholderHoverColor: '',
			selectPlaceholderFocusColor: '#39442B',
			selectPlaceholderActiveColor: '',
			selectPlaceholderErrorColor: '#FF7D82',
			selectPlaceholderDisabledColor: '',

			selectBorderColor: '#39442B',
			selectBorderHoverColor: '#39442B',
			selectBorderFocusColor: '#39442B',
			selectBorderActiveColor: '',
			selectBorderErrorColor: '#FF7D82',
			selectBorderDisabledColor: '#E9EBDC',

			selectBgColor: '#FAFF86',
			selectHoverBgColor: '',
			selectFocusBgColor: '',
			selectActiveBgColor: '',
			selectErrorBgColor: '#FFEFE5',
			selectDisabledBgColor: '#E9EBDC',

			selectOptionColor: '#39442B',
			selectOptionHoverColor: '',
			selectOptionFocusColor: '',
			selectOptionActiveColor: '#39442B',
			selectOptionErrorColor: '#FF7D82',
			selectOptionDisabledColor: '',

			selectOptionBgColor: '#FAFF86',
			selectOptionHoverBgColor: '',
			selectOptionFocusBgColor: '#39442B',
			selectOptionActiveBgColor: '',
			selectOptionErrorBgColor: '#FFEFE5',
			selectOptionDisabledBgColor: '',

			//! Radio
			radioBorderColor: '#39442B',
			radioBorderActiveColor: '#39442B',
			radioBgColor: '#FFFFFB',
			radioActiveBgColor: '#39442B',

			//! Upload
			uploadBgColor: 'rgba(0, 0, 0, 0.02)',
			uploadBorderColor: '#d9d9d9',
		},
	},
};

export default theme;
